import { AppBar, Autocomplete, Box, Button, MenuItem, Select, TextField, InputAdornment, OutlinedInput, IconButton } from '@mui/material'
import { Divider, Tab, Tabs, Grid, Pagination, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'

import React, { useEffect, useState } from 'react'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useNavigate } from 'react-router-dom'
import Avatar from '@mui/material/Avatar'
import SwipeableViews from "react-swipeable-views";

import {

    ApiPutHistory,
} from 'utils/api/analytics'

import {
    ApiFindMyHealthHistory,
    ApiFindCheckList,
} from 'utils/api/data'
import moment from 'moment';

import { formatDate } from 'utils/function'
import { width } from '@mui/system';

import Nodata from 'utils/components/nodata';
import TableCustom from 'utils/components/table-custom-v1'

import DialogAlert from 'utils/components/modal-alert'
import DialogSubmit from 'utils/components/modal-submit'


function TabPanel({ children, value, index }) {
    return (
        <div role="tabpanel" hidden={value !== index}>
            {value === index &&
                <Box sx={{
                    p: 3,
                    "@media (max-width: 800px)": {
                        p: 0
                    },
                }}>{children}</Box>}
        </div>
    );
}


function EditPersonalHealthData() {
    const navigate = useNavigate()
    const [data, setData] = useState({})
    const [value, setValue] = useState(0);
    const [findGroupList, setFindGroupList] = useState([]);
    const [loading, setLoading] = useState(false)

    const [alertData, setAlertData] = useState([]);
    const [openAlert, setOpenAlert] = useState(false)
    const [alertType, setAlertType] = useState('')
    const [errorMessage, setErrorMessage] = useState('')


    const handleOpenAlert = (type) => {
        setOpenAlert(type)
    }
    const [openSubmit, setOpenSubmit] = useState(false)
    const [typeSubmit, setTypeSubmit] = useState('')
    const [dataSubmit, setDataSubmit] = useState(null)
    const [filter, setFilter] = useState({
        "year": "",
        "inspection_round": "",
        "pid": "",
        "hospital_code": "",
        "department_code": "",
    })

    const handleOpenSubmit = async (type, reset, payload,query) => {
        setOpenSubmit(type)
        if (reset) {
            
            let result = await ApiPutHistory(payload,filter)
            if (result.status) {
                setLoading(false)
                setMessageAlert('สำเร็จ')
                setAlertType('success')
                handleOpenAlert(true)
                setErrorMessage('');
                setTimeout(() => {
                    handleOpenAlert(false)
                    setMessageAlert('')
                    setAlertType('')
                }, 1000);

            }
            setTypeSubmit('')
            getParameter()
        }
    }
    const [messageAlert, setMessageAlert] = useState('')


    useEffect(() => {
        getParameter()
    }, [])

    const getParameter = () => {
        let pid = new URLSearchParams(window.location.search).get('pid')
        let year = new URLSearchParams(window.location.search).get('year')
        let inspection_round = new URLSearchParams(window.location.search).get('inspection_round')
        let hospital_code = new URLSearchParams(window.location.search).get('hospital_code')
        let department_code = new URLSearchParams(window.location.search).get('department_code')
        setData({
            ...data, pid: pid, year: year, inspection_round: inspection_round, hospital_code: hospital_code, department_code: department_code,
        })
        fetchData({
            pid: pid,
            year: year,
            inspection_round: inspection_round,
            hospital_code: hospital_code,
            dep_code: department_code,
        })
        setFilter({
            ...filter,
            pid: pid,
            year: year,
            department_code: department_code,
            inspection_round: inspection_round,
            hospital_code: hospital_code,
        })
    }





    const fetchData = async (payload) => {


        try {
            // First API call
            let result = await ApiFindMyHealthHistory(payload);

            if (result.status) {
                let HealthHistory = result.data[0];

                // Set health history data
                setData({ ...data, ...HealthHistory });

                // Second API call for checklist
                let res = await ApiFindCheckList({ group: true });

                if (res.status) {
                    // let payload = res.data;
                    let payload = [{
                        "checklist_group_code": "CK-00",
                        "checklist_group_name": "ข้อมูลส่วนตัว",
                        "checklist": [
                            {
                                "checklist_group_code": "CK-00",
                                "line_number": 1,
                                "field": "year",
                                "field_name": "ปี",
                                "standard": '',
                                "checklist_group_name": "ข้อมูลส่วนตัว",
                                "value": data ?? data['year'],
                                "new_value": data ?? data['year']
                            },
                            {
                                "checklist_group_code": "CK-00",
                                "line_number": 2,
                                "field": "inspection_round",
                                "field_name": "รอบตรวจ",
                                "standard": '',
                                "checklist_group_name": "ข้อมูลส่วนตัว",
                                "value": data ?? data['inspection_round'],
                                "new_value": data ?? data['inspection_round'],
                            },
                            {
                                "checklist_group_code": "CK-00",
                                "line_number": 3,
                                "field": "pid",
                                "field_name": "เลขบัตรประชาชน",
                                "standard": "",
                                "checklist_group_name": "ข้อมูลส่วนตัว",
                                "value": data ?? data['pid'],
                                "new_value": data ?? data['pid'],
                            },
                            {
                                "checklist_group_code": "CK-00",
                                "line_number": 4,
                                "field": "gender",
                                "field_name": "เพศ",
                                "standard": "",
                                "checklist_group_name": "ข้อมูลส่วนตัว",
                                "value": data ?? data['gender'],
                                "new_value": data ?? data['gender'],
                            },
                            {
                                "checklist_group_code": "CK-00",
                                "line_number": 5,
                                "field": "code_number",
                                "field_name": "รหัส",
                                "standard": "",
                                "checklist_group_name": "ข้อมูลส่วนตัว",
                                "value": data ?? data['code_number'],
                                "new_value": data ?? data['code_number'],
                            },
                            {
                                "checklist_group_code": "CK-00",
                                "line_number": 6,
                                "field": "pname",
                                "field_name": "คำนำหน้า",
                                "standard": "",
                                "checklist_group_name": "ข้อมูลส่วนตัว",
                                "value": data ?? data['pname'],
                                "new_value": data ?? data['pname'],
                            },
                            {
                                "checklist_group_code": "CK-00",
                                "line_number": 7,
                                "field": "fname",
                                "field_name": "ชื่อ",
                                "standard": "",
                                "checklist_group_name": "ข้อมูลส่วนตัว",
                                "value": data ?? data['fname'],
                                "new_value": data ?? data['fname'],
                            }, {
                                "checklist_group_code": "CK-00",
                                "line_number": 8,
                                "field": "lname",
                                "field_name": "นามสกุล",
                                "standard": "",
                                "checklist_group_name": "ข้อมูลส่วนตัว",
                                "value": data ?? data['lname'],
                                "new_value": data ?? data['lname'],
                            }, {
                                "checklist_group_code": "CK-00",
                                "line_number": 9,
                                "field": "age",
                                "field_name": "อายุ",
                                "standard": "",
                                "checklist_group_name": "ข้อมูลส่วนตัว",
                                "value": data ?? data['age'],
                                "new_value": data ?? data['age'],
                            }, {
                                "checklist_group_code": "CK-00",
                                "line_number": 10,
                                "field": "department_code",
                                "field_name": "สังกัด",
                                "standard": "",
                                "checklist_group_name": "ข้อมูลส่วนตัว",
                                "value": data ?? data['department_code'],
                                "new_value": data ?? data['department_code'],
                            }

                        ]
                    }]


                    res.data.forEach(element => {
                        payload.push(element)
                    });
                    // Update checklist values based on health history
                    payload.forEach(element => {
                        element.checklist.forEach(item => {
                            // if (['gender'].includes(item.field)) {
                            //     item.select = 'gender'

                            // }
                            item.value = HealthHistory[item.field] || '';
                            item.new_value = HealthHistory[item.field] || '';
                        });
                    });

                    // Set the updated checklist
                    setFindGroupList(payload);
                } else {
                    setFindGroupList([]);
                }
            }
        } catch (error) {
            // Handle any errors that occur in the try block
            console.error('Error fetching data:', error);
            setFindGroupList([]);
        }




    }


    const handleListener = (value, payload) => {
        setFindGroupList((prevGroupList) => {
            // Create a deep copy of the current state
            const updatedGroupList = [...prevGroupList];

            // Find the index of the group to modify
            const findIdx = updatedGroupList.findIndex(
                (d) => d.checklist_group_code === payload.row.checklist_group_code
            );

            // If the group is found, update the specific value
            if (findIdx !== -1) {
                const group = updatedGroupList[findIdx];
                const updatedChecklist = [...group.checklist];
                updatedChecklist[payload.index] = {
                    ...updatedChecklist[payload.index],
                    [payload.name]: value,
                };
                updatedGroupList[findIdx] = { ...group, checklist: updatedChecklist };
            }
            return updatedGroupList;
        });
    };


    const handleSubmit = async () => {

        const payload = {
            ...data,
            ...findGroupList.reduce((acc, element) => {
                element.checklist.forEach((item) => {
                    acc[item.field] = item.new_value;
                });
                return acc;
            }, {}),
        };

        
        handleOpenSubmit(true, false,filter)
        setTypeSubmit('ยืนยันการบันทึก ?')
        setDataSubmit(payload)


    }


    const handleAlert = () => {

    }

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px', // `gap` is preferred over `gridGap`
                    cursor: 'pointer', // Move `cursor` to the parent for consistency
                }}
                onClick={() => { navigate('/importHealthData') }}
            >
                <KeyboardBackspaceIcon sx={{ fontSize: '20px' }} />
                <Box>
                    กลับไป นำเข้าข้อมูลสุขภาพ
                </Box>
            </Box>

            <Box sx={{ display: "grid", gridGap: "10px", pt: 4 }}>

                <Box sx={{
                    backgroundColor: '#EBF5FF',
                    padding: '20px',
                    display: 'grid',
                    gridTemplateColumns: '1fr 4fr',
                    gridGap: '40px',
                    "@media (max-width: 100px)": {
                        gridTemplateColumns: '1fr',
                        gridGap: '10px',
                        padding: '10px'
                    },
                }}>
                    <Box sx={{ flex: 1 }}>
                        <Box sx={{
                            width: '100%',
                            height: '100%',
                            backgroundColor: '#FFFFFF',
                            borderRadius: '10px',
                            "@media (max-width: 100px)": {
                                minHeight: '160px'
                            },
                        }}>
                            <Box>
                                <Box
                                    sx={{
                                        width: '100%',
                                        height: '100%',
                                        backgroundColor: '#FFFFFF',
                                        borderRadius: '10px',
                                        display: 'flex',
                                        flexDirection: 'column', // Arrange content vertically
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        overflow: 'hidden', // Keeps content within the rounded box
                                        "@media (max-width: 500px)": {
                                            minHeight: '160px',
                                        },
                                    }}
                                >
                                    <Avatar
                                        sx={{
                                            width: '200px', // Size of the avatar
                                            height: '200px',
                                            borderRadius: '10px',
                                        }}
                                        alt={`${data['titlename']} ${data['firstname']} ${data['lastname']}`}
                                        src={data['image_url']}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{
                        display: 'grid',
                        gridGap: '10px',
                        flex: 1, // Added flex: 1 to take up remaining space
                        "@media (max-width: 800px)": {
                            fontSize: '14px'
                        }
                    }}>
                        <Box sx={{ color: '#478F96', fontWeight: 600 }}>ข้อมูลส่วนตัว</Box>
                        <Box><span style={{ fontWeight: 600 }}>ชื่อ-สกุล :</span> <span>{data.full_name}</span></Box>
                        <Box><span style={{ fontWeight: 600 }}>เพศ :</span> <span>{data.gender}</span></Box>
                        {/* <Box><span style={{ fontWeight: 600 }}>วันเดือนปีเกิด :</span> <span>{data.date_of_birth ? formatDate(data.date_of_birth) : ''}</span></Box> */}
                        <Box><span style={{ fontWeight: 600 }}>เลขบัตรประชาชน :</span> <span>{data.pid}</span></Box>
                        <Box><span style={{ fontWeight: 600 }}>สังกัด :</span> <span></span>{data.department_name}</Box>
                    </Box>



                </Box>

                <Box sx={{
                    // display: 'grid',
                    // gridGap: '10px',
                    // flex: 1, // Added flex: 1 to take up remaining space
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>


                </Box>


                <Box
                    sx={{
                        // height: '450px',
                        border: '1px solid #478F96',
                        borderRadius: '10px',
                        // display: 'flex',
                        justifyContent: 'center', // Center content horizontally
                        alignItems: 'center',    // Center content vertically
                        // pt: 5,
                        // pb: 5,
                        // pt: 5,
                        // pl: 5
                    }}
                >



                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            padding: '0 5px',
                            // height: "400px"
                        }}
                    >
                        <Tabs
                            variant="scrollable"
                            allowScrollButtonsMobile
                            value={value}
                            onChange={(event, newValue) => setValue(newValue)}
                        // sx={{ p: "0px 5px" }}
                        >
                            {findGroupList && findGroupList?.length > 0 ? findGroupList.map(d => {
                                return (
                                    <Tab label={d.checklist_group_name}
                                        sx={{
                                            fontWeight: 'bold',
                                            // backgroundColor: (theme) => theme.palette.primary.main,
                                            color: '#478F96',
                                            '&.Mui-selected': {
                                                backgroundColor: '#A3D5D5', // Change color when selected
                                                color: '#006D6D', // Change text color when selected
                                            },
                                        }}
                                    />
                                )
                            }
                            ) : null}
                        </Tabs>
                        <Divider />
                        <SwipeableViews
                            index={value}
                            onChangeIndex={(index) => setValue(index)}
                        >
                            {findGroupList && findGroupList?.length > 0 ? findGroupList.map((d, index) => {
                                let config_head = []
                                let config_body = []
                                if (d.checklist_group_code === 'CK-00') {
                                    let configHead = [
                                        { name: "ค่าที่ตรวจ", minWidth: "260px", align: 'left' },
                                        { name: "ค่าเดิม", minWidth: "60px", align: 'right' },
                                        { name: "ค่าที่แก้", minWidth: "60px", name2: '(ถ้าไม่แก้ไขให้เว้นว่าง)', align: 'right' }
                                    ]
                                    let configBody = [
                                        { name: 'field_name', align: 'left', type: 'field_name' },
                                        { name: 'value', align: 'right' },
                                        { name: 'new_value', align: 'right', type: 'edit_value' }
                                    ]
                                    config_head = configHead
                                    config_body = configBody
                                } else if (d.checklist_group_code === 'CK-01') {
                                    let configHead = [
                                        { name: "ค่าที่ตรวจ", minWidth: "260px", align: 'left' },
                                        { name: "ค่าเดิม", minWidth: "60px", align: 'right' },
                                        { name: "ค่าที่แก้", minWidth: "60px", name2: '(ถ้าไม่แก้ไขให้เว้นว่าง)', align: 'right' }

                                    ]
                                    let configBody = [
                                        { name: 'field_name', align: 'left', type: 'field_name' },
                                        { name: 'value', align: 'right' },
                                        { name: 'new_value', align: 'right', type: 'edit_value' }
                                    ]
                                    config_head = configHead
                                    config_body = configBody
                                } else if (d.checklist_group_code === 'CK-02') {
                                    let configHead = [
                                        { name: "ค่าที่ตรวจ", minWidth: "260px", align: 'left' },
                                        { name: "ค่าเดิม", minWidth: "60px", align: 'right' },
                                        { name: "ค่าที่แก้", minWidth: "60px", name2: '(ถ้าไม่แก้ไขให้เว้นว่าง)', align: 'right' }

                                    ]
                                    let configBody = [
                                        { name: 'field_name', align: 'left', type: 'field_name' },
                                        { name: 'value', align: 'right' },
                                        { name: 'new_value', align: 'right', type: 'edit_value' }
                                    ]
                                    config_head = configHead
                                    config_body = configBody
                                } else if (d.checklist_group_code === 'CK-03') {
                                    let configHead = [
                                        { name: "ค่าที่ตรวจ", minWidth: "260px", align: 'left' },
                                        { name: "ค่าเดิม", minWidth: "60px", align: 'right' },
                                        { name: "ค่าที่แก้", minWidth: "60px", name2: '(ถ้าไม่แก้ไขให้เว้นว่าง)', align: 'left' }

                                    ]
                                    let configBody = [
                                        { name: 'field_name', align: 'left', type: 'field_name' },
                                        { name: 'value', align: 'right' },
                                        { name: 'new_value', align: 'right', type: 'edit_value' }
                                    ]
                                    config_head = configHead
                                    config_body = configBody
                                } else if (d.checklist_group_code === 'CK-04') {
                                    let configHead = [
                                        { name: "ค่าที่ตรวจ", minWidth: "260px", align: 'left' },
                                        { name: "ค่าเดิม", minWidth: "60px", align: 'right' },
                                        { name: "ค่าที่แก้", minWidth: "60px", name2: '(ถ้าไม่แก้ไขให้เว้นว่าง)', align: 'right' }

                                    ]
                                    let configBody = [
                                        { name: 'field_name', align: 'left', type: 'field_name' },
                                        { name: 'value', align: 'right' },
                                        { name: 'new_value', align: 'right', type: 'edit_value' }
                                    ]
                                    config_head = configHead
                                    config_body = configBody
                                } else if (d.checklist_group_code === 'CK-05') {
                                    let configHead = [
                                        { name: "ค่าที่ตรวจ", minWidth: "260px", align: 'left' },
                                        { name: "ค่าเดิม", minWidth: "60px", align: 'right' },
                                        { name: "ค่าที่แก้", minWidth: "60px", name2: '(ถ้าไม่แก้ไขให้เว้นว่าง)', align: 'right' }

                                    ]
                                    let configBody = [
                                        { name: 'field_name', align: 'left', type: 'field_name' },
                                        { name: 'value', align: 'right' },
                                        { name: 'new_value', align: 'right', type: 'edit_value' }
                                    ]
                                    config_head = configHead
                                    config_body = configBody
                                }

                                return (
                                    <TabPanel value={value} index={index}>
                                        {d?.checklist && d?.checklist?.length > 0 ? <TableCustom
                                            data={{ data: d?.checklist }}
                                            handlelistener={handleListener}
                                            pagination={false}
                                            sx={{ height: "100%" }}
                                            head={config_head}
                                            body={config_body}
                                        /> : null}
                                    </TabPanel>
                                )
                            }
                            ) : <Nodata />}


                        </SwipeableViews>
                    </Box>



                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 2, marginRight: 4.3 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        sx={{ padding: 1, borderRadius: 1.5 }}
                    >
                        <p style={{ fontWeight: 600, margin: 0, fontSize: 12, padding: '0 40px' }}>บันทึก</p>
                    </Button>
                </Box>



                <DialogAlert
                    loading={loading}
                    title={'แจ้งเตือน'}
                    type={alertType}
                    message={messageAlert}
                    open={openAlert}
                    setOpen={setOpenAlert}
                    handleChange={handleAlert}
                    data={alertData}

                />

                <DialogSubmit
                    title={`${typeSubmit}`}
                    open={openSubmit}
                    setOpen={setOpenSubmit}
                    handleOpenSubmit={handleOpenSubmit}
                    data={dataSubmit}
                />



            </Box>

        </>

    )
}

export default EditPersonalHealthData